<template>
  <div class="columns is-mobile feature">
    <div class="column is-one-third-tablet is-one-quarter-mobile has-text-right">
      <div class="icon-container">
        <b-icon :icon="icon" :size="iconSize"></b-icon>
      </div>
    </div>
    <div class="column is-two-thirds-tablet is-three-quarters-mobile">
      <p class="title is-3">{{ title }}</p>
      <p class="subtitle is-5">
        {{ subtitle }}
      </p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomeFeature',
  props: ['icon', 'subtitle', 'title'],
  computed: {
    iconSize() {
      if (this.$mq.above(this.$mv.mobile)) {
        return 'is-large'
      }

      return 'is-medium'
    }
  }
}
</script>

<style scoped lang="scss">
.columns.feature {
  margin-bottom: 80px;
}

.icon-container {
  background: #7957d5;
  border: 5px solid #9b67df;
  border-radius: 200px;
  display: inline-block;
  margin: 0 60px;
  padding: 15px;

  .icon {
    color: #fff;
  }

  @media only screen and (max-device-width : 768px) {
    margin: 0;
    padding: 10px;
  }
}

</style>
